/**
 * ARIA Roles
 * https://www.w3.org/TR/wai-aria-1.2/#roles_categorization
 */

export const BUTTON = 'button'
export const CHECKBOX = 'checkbox'
export const RADIO = 'radio'

/**
 * ARIA Attributes
 * https://www.w3.org/TR/wai-aria-1.1/#state_prop_taxonomy
 */

export const ARIA_LABEL = 'aria-label'

/**
 * ARIA States
 * https://www.w3.org/TR/wai-aria-1.1/#state_prop_taxonomy
 */

export const ARIA_CHECKED = 'aria-checked'
export const ARIA_CHECKED_TRUE = `${ARIA_CHECKED}="true"`
export const ARIA_CHECKED_FALSE = `${ARIA_CHECKED}="false"`
export const ARIA_PRESSED = 'aria-pressed'
export const ARIA_PRESSED_TRUE = `${ARIA_PRESSED}="true"`
export const ARIA_PRESSED_FALSE = `${ARIA_PRESSED}="false"`
export const ARIA_DISABLED = 'aria-disabled'
